import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import settings from '../config/settings';
import axios from "axios";
import {
  CForm,
  CInputGroup,
  CHeader,
  CToggler,
  CHeaderBrand,
  CInput,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink,
  CCol,
  CButton,
  CRow,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  //CImg,
} from '@coreui/react'
import { CImg } from '@coreui/react'
import { Link, useHistory } from 'react-router-dom'
// import SimpleImageSlider from "react-simple-image-slider";
import DocumentDetails from '../views/details/DocumentDetails'
// routes config
import routes from '../routes'
import "./header.css"

import {
  TheHeaderDropdown,
  TheHeaderDropdownMssg,
  TheHeaderDropdownNotif,
  TheHeaderDropdownTasks
} from './index'
import { SportsRugbySharp } from '@material-ui/icons';
import { Grid, Stack } from '@mui/material';
import zIndex from '@material-ui/core/styles/zIndex';
import { handleApiError } from '../session/session-expire';

const useStyles = makeStyles(theme => ({

  header_bg: {
    background: "rgb(131,73,191)",
    background: "linear-gradient(-90deg, rgba(131,73,191,1) 16%, rgba(25,229,246,1) 84%)",
    width: "100%",
    display: "table",
    position: "fixed",
    zIndex: "0",
    height: "130px",
    top: "0",
    "@media (max-width: 1200px)": {
      height: "230px",
    },
    "@media (max-width: 767px)": {
      height: "260px",
    }
  },

  header_icon: {
    width: "200px",
    display: "block",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    "@media (max-width: 767px)": {
      marginTop: "0",
    }
  },
  back_icon: {
    position: "absolute",
    left: "30px",
    bottom: "12px",
    "@media (max-width: 1200px)": {
      bottom: "25px"
    },
    // "@media (max-width: 767px)": {
    //   bottom: "67px"
    // }
  },
  header_bg1: {
    background: "rgb(131,73,191)",
    background: "linear-gradient(-90deg, rgba(131,73,191,1) 16%, rgba(25,229,246,1) 84%)",
    zIndex: "20",
    border: "0",
    paddingRight: "20px",
    paddingBottom: "15px",
    position: "fixed",
    display: 'flex',
    top: 10,
    zIndex: 1000
  },
 
  logo_image: {
    textDecoration: 'none',
    whiteSpace: "nowrap",
    background: "url(./dg_logo.png) no-repeat",
    backgroundSize: "45px",
    padding: "20px 0px 20px 60px",
    backgroundPosition: "0 50%",
    color: "#fff",
    display: "block",
    marginLeft: "40px",
    fontSize: "1.2em",
    float:"left",
    "@media (max-width: 1200px)": {
      // backgroundSize: "70px",
      // padding: "40px 0px 40px 90px",
      // backgroundPosition: "0 50%",
      // fontSize: "1.6em",
    }

  }

}
));
const toast_options = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3
  }
};
const TheHeaderNew = (props) => {
  const history = useHistory()

  const [urlVal, SetUrlVal] = useState("")
  // const [urlValTrue, SetUrlValTrue] = useState(false)
  const [sliderData, SetSliderData] = useState(["./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png"])

  const [counter, setCounter] = useState(0)


  const [Toggle, setToggle] = useState(false)

  const dispatch = useDispatch()
  const classes = useStyles();
  const sidebarShow = useSelector(state => state.sidebarShow)
  const companySelectedVal = useSelector(state => state.companySelectedVal)
  // console.log('companySelectedVal :>> ', companySelectedVal);

  const url = useSelector(state => state.url)
  const compId = useSelector(state => state.companyId)
  const companyList = useSelector(state => state.companyList)

  console.log("companyList::", companyList)

  const [CompanyDropdown, setCompanyDropdownValue] = useState(compId);


  useEffect(() => {
    if (localStorage.getItem("access_token")) {

      getCompanyData();
    }
    else {
      localStorage.clear()
      history.push("/");
    }
  }, [])

  const getCompanyData = () => {


    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem('access_token'),
      // reqFrom: "ADMIN",
    };
    axios({
      method: "GET",
      url: settings.serverUrl + "/getCompaniesData",
      headers,
    }).then((response) => {
      console.log("Response from header company list===", response.data.result);
      if (response.data.err) {
        toast.error(response.data.err, toast_options);
      } else {
        if (response.data.result) {
          dispatch({ type: 'set', companyList: response.data.result })
        }
      }
    }).catch(err => {
       handleApiError(err, history);
      // toast.error(err.message, toast_options);
      // console.log("Record Issue Error Processor Data", err)
      // if (err.message.includes("403")) {
      //   localStorage.clear();
      //   history.push("/");
      // }
    });
  }

  console.log("url props::", props)
  // console.log("urlVal", urlVal);
  // console.log("useEffect")

  // console.log("url props::", this.props.document)




  // const urll = () => {
  //   let CurrUrl = window.location.href
  //   console.log("CurrUrl", CurrUrl);
  //   let lastSegment = CurrUrl.split("/").pop();
  //   SetUrlVal(lastSegment)
  //   console.log("urlVl", urlVal)

  //   dispatch({ type: 'set', sidebarShow: val })
  // }
  const handleCompanyChange = (e) => {
    setCompanyDropdownValue(e.target.value)
    dispatch({ type: 'set', companyId: e.target.value })
    localStorage.setItem('companyId', e.target.value)

    // console.log('companySelectedVal :::::', e.target.value);
    history.push("/incoming_list");
  }

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  let change = ""
  if (window.location.href.includes("detail")) {
    change = "detail page"
  }

  if (window.location.href.includes("details")) {
    change = "details page"
  }

  if (window.location.href.includes("incoming")) {
    change = "incoming page"
  }
  console.log("change", change)



  const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    console.log("currentSlide: ", currentSlide);
    console.log("deviceType: ", deviceType);
    setCounter(currentSlide)
    // onMove means if dragging or swiping in progress.
    return <button onClick={() => {
      onClick();
      //RightArrow();
    }} className={classes.carousel_arrow_right} ><i class="fa fa-chevron-right" aria-hidden="true"></i></button>;
  };

  const CustomLeftArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    setCounter(currentSlide)
    // onMove means if dragging or swiping in progress.
    return <button onClick={() => {
      onClick();
      //LeftArrow();
    }} className={classes.carousel_arrow_left} ><i class="fa fa-chevron-left" aria-hidden="true"></i></button>;
  };
  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
      <div className="carousel-button-group" style={{ position: "absolute", zIndex: "1", bottom: "12px", right: "40px" }}>
        {/* <CButton className={currentSlide === 0 ? 'disable' : ''} onClick={() => previous()} />
        <CButton onClick={() => next()} /> */}
        <div style={{ color: "#fff", textAlign: "right", marginTop: "15px" }}>Pages
          <CInput type='text'
            value={counter}
            onChange={(e) => {
              goToSlide(e.target.value);
              setCounter(e.target.value)
            }}
            style={{
              background: "none",
              color: "#fff",
              borderRadius: "0",
              margin: "0 7px",
              width: "50px",
              border: "1px solid #fff",
              textAlign: "center",
              display: 'inline-block'
            }}
          /> of {sliderData.length}</div>
        {/* <CButton onClick={() => goToSlide(currentSlide + 4)} > Go to any slide </CButton> */}
      </div>
    );
  };
  const sliderClick = () => {
    setToggle(!Toggle)
  }


  console.log("Toggle", Toggle)
  return (
    <>
      <div className="header_bg1">
       
          <Link
            to="/incoming_list"
            className={classes.logo_image}>
            IMAGE DATA EXTRACT
          </Link>
        
          
        
          <div style={{width:360, float:"right", marginTop:10}}>
          <div style={{float:"left", marginRight:20, marginTop:5, position:"relative", zIndex:2}}>
              {
            localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
            <select
              className="master_dropdown"
              value={CompanyDropdown}
              name="company"
              onChange={handleCompanyChange}>
              <option value="">Select Company</option>
              {companyList.map((curr, index) => {
                return (
                  <>
                    <option value={curr.comp_id} >
                      {curr.name}
                    </option>

                  </>
                );
              })}
            </select>
          }
       </div>
              <CDropdown direction="down" style={{float:"left", zIndex: 2}}>
                <CDropdownToggle className="c-header-nav-link" caret={false} style={{float:"left"}}>
                  <h2 className="grid_icon">
                    <i class="fa fa-th" aria-hidden="true"></i>
                  </h2>


                </CDropdownToggle>
                <CDropdownMenu className="pt-0" placement="bottom-end" style={{ background: "none", border: "0" }}>
                  <div className="header_grid" style={{ width: localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) ? "450px" : "150px" }}>
                    <div className="trianglePoint"></div>
                    <CRow>
                      {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                        <CCol sm="4">
                          <div className="grid_link" onClick={() => { history.push('/compnies') }}>
                            <span>
                              <h2 style={{ opacity: "0.5" }}><i class="fa fa-building" aria-hidden="true"></i></h2>
                              <h5 style={{ fontSize: '18px' }}>Companies List</h5>
                            </span>
                          </div>
                        </CCol>
                      }
                      <CCol sm="4" style={{ borderLeft: localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) && "1px solid rgb(234, 234, 234)" }}>

                        <div className="grid_link" onClick={() => { history.push('/companyUser') }}>
                          <span>
                            <h2 style={{ opacity: "0.5" }}><i class="fa fa-user" aria-hidden="true"></i></h2>
                            <h5 style={{ fontSize: '19px' }}>Users List</h5>
                          </span>
                        </div>
                      </CCol>
                      {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                        <CCol sm="4" style={{ borderLeft: "1px solid rgb(234, 234, 234)" }}>
                          <div className="grid_link" onClick={() => { history.push('/processors') }}>
                            <span>
                              <h2 style={{ opacity: "0.5" }}><i class="fa fa-cogs" aria-hidden="true"></i></h2>
                              <h5 style={{ fontSize: '19px' }}>Processor List</h5>
                            </span>
                          </div>
                        </CCol>
                      }
                    </CRow>
                  </div>
                </CDropdownMenu>

              </CDropdown>
            
              <TheHeaderDropdown />
              </div>
              

      </div>
      {/* <div className={classes.header_bg}></div>
      <CHeader withSubheader className={classes.header_bg1}>
        <CHeaderNav className="mr-auto">
          <CHeaderNavItem >
            <Link 
            // to="/document_list" 
            to="/incoming_list"
            className={classes.logo_image}>
              IMAGE DATA EXTRACT
            </Link>
          </CHeaderNavItem>

          {console.log('header rendewrlocalStorage.getItem(master) :>> ', localStorage.getItem('master'))}

          {
          localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
            <select
            style={master_dropdown}
            value={CompanyDropdown}
            name="company"
            onChange={handleCompanyChange}>
            <option value="">Select Company</option>
            {companyList.map((curr, index) => {
              return (
                <>
                  <option value={curr.comp_id}>{curr.name}</option>
                </>
              );
            })}
           </select>   
          }
                 
        </CHeaderNav>
        <CHeaderNav className={classes.right_content}>

          <CDropdown inNav className="c-header-nav-items mx-3" direction="down">
            <CDropdownToggle className="c-header-nav-link" caret={false}>
              <h2 className={classes.grid_icon}>
                <i class="fa fa-th" aria-hidden="true"></i>
              </h2>


            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end" style={{background:"none", border:"0"}}>
              <div className={classes.header_grid} style={{width:localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) ?"450px":"150px"}}>
              <div className={classes.trianglePoint}></div>
              <CRow>
              {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                <CCol sm="4">
               <div className={classes.grid_link} onClick={() => { history.push('/compnies') }}>
                 <span>
                 <h2 style={{opacity: "0.5"}}><i class="fa fa-building" aria-hidden="true"></i></h2>
                 <h5>Companies List</h5>  
                 </span>               
                 </div> 
                  </CCol>
                }
                <CCol sm="4" style={{borderLeft:localStorage.getItem('master') && JSON.parse(localStorage.getItem('master'))&&"1px solid rgb(234, 234, 234)"}}>
                  
                <div className={classes.grid_link} onClick={() => { history.push('/companyUser') }}>
                  <span>
                <h2 style={{opacity: "0.5"}}><i class="fa fa-user" aria-hidden="true"></i></h2>
                 <h5>Users List</h5>    
                 </span>              
                  </div>
                  </CCol>
                  {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                <CCol sm="4" style={{borderLeft:"1px solid rgb(234, 234, 234)"}}>
                <div className={classes.grid_link} onClick={() => { history.push('/processors') }}>
                  <span>
                <h2 style={{opacity: "0.5"}}><i class="fa fa-cogs" aria-hidden="true"></i></h2>
                 <h5>Processor List</h5>
                 </span>
                  </div>
                  </CCol>
}
              </CRow>
            </div>
            </CDropdownMenu>
            
          </CDropdown>
          <TheHeaderDropdown />
        </CHeaderNav>

        <CSubheader className={classes.bottom_content} style={{ border: "0" }}>
          <CRow>

            <CCol md="8">
              <h4 className={classes.acc_activity}>&nbsp;</h4>
            </CCol>

            <CCol md="4">
              {
                change == 'incoming page' &&
                <div style={{ width: "100%" }}>
                  <CRow>
                    <CCol>
                      <div className={classes.report_block}>
                        <h4 className={classes.report_title} >&nbsp;
                        </h4>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              }

            </CCol>
            {
              change == 'incoming page' ?
                <div className={classes.back_icon}></div>
                :
                <div className={classes.back_icon}>
                  <CButton onClick={() => {
                    history.goBack()
                  }}
                    class="fa fa-chevron-circle-left" aria-hidden="true" style={{ color: "#fff", fontSize: "2em", border: "none", background: "none" }}>

                  </CButton>
                </div>
            }
          </CRow>

        </CSubheader>

      </CHeader > */}
    </>
  )
}

export default TheHeaderNew
